export const storage =
  process.env.ENVIRONMENT === "development" ? localStorage : sessionStorage;
